import { DATA_PRODUCER_WORKSHEET_NAME } from "../globalValues";
import { DATA_PRODUCER_TABLE_NAME } from "./constants";
import { protectDataProducerSheet } from "./lockEditModeInSomeColumns";

export async function deleteSecurityProducer(context: Excel.RequestContext, securities: string[]) {
  if (!securities.length) return null;

  const sheet = context.workbook.worksheets.getItem(DATA_PRODUCER_WORKSHEET_NAME);
  const table = sheet.tables.getItemOrNullObject(DATA_PRODUCER_TABLE_NAME);
  await context.sync();

  if (table.isNullObject) return null;

  const range = table.getDataBodyRange();
  range.load("values");
  await context.sync();

  let values = range.values;
  let rowsToDeleteIndexes = [];

  for (let i = 0; i < values.length; i++) {
    if (!securities.includes(values[i][1])) {
      continue;
    }

    rowsToDeleteIndexes.push(i);
  }

  if (!rowsToDeleteIndexes.length) return null;

  sheet.protection.unprotect();

  table.rows.deleteRows(rowsToDeleteIndexes);

  await protectDataProducerSheet({ worksheet: sheet });

  await context.sync();

  return rowsToDeleteIndexes as number[];
}
